import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from './PasswordIcons';
import './LoginScreen.css';

export default function LoginScreen({ logo, institutionName = 'OnTest', kicker, subtitle, background, heroTitle, heroDescription, credential, credentialOptions, password, onPasswordChange, onSubmit, error, submitting, loginText, recoveryLink }) {
    const [showPassword, setShowPassword] = useState(false);
    return <div className="ontest-access">
        <section className="access-panel" aria-label={kicker}>
            <div className="access-body">
                <div className="access-logo"><img src={logo} alt={institutionName || 'OnTest'} /></div>
                <div className="access-intro">
                    <span className="access-kicker">{kicker}</span>
                    <h1 className="access-title">Bem-vindo</h1>
                    <p className="access-subtitle">{subtitle}</p>
                </div>
                <form className="access-form" onSubmit={onSubmit}>
                    {credentialOptions && <div className="access-field">
                        <label htmlFor="access-credential">{credentialOptions.label} <span aria-hidden="true">*</span></label>
                        <input id="access-credential" name="credencial" type="text" value={credential} onChange={credentialOptions.onChange} placeholder={credentialOptions.placeholder} inputMode={credentialOptions.inputMode} autoComplete="username" required autoFocus />
                    </div>}
                    <div className="access-field">
                        <label htmlFor="access-password">Senha <span aria-hidden="true">*</span></label>
                        <div className="access-password">
                            <input id="access-password" name="password" type={showPassword ? 'text' : 'password'} value={password} onChange={onPasswordChange} placeholder="Digite sua senha" autoComplete="current-password" required />
                            <button className="access-password-toggle" type="button" aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={showPassword} onClick={() => setShowPassword(value => !value)}>
                                {showPassword ? <AiFillEyeInvisible aria-hidden="true" /> : <AiFillEye aria-hidden="true" />}
                            </button>
                        </div>
                        {loginText != null && <span className="access-help" role="alert">{loginText}</span>}
                        {recoveryLink && <a className="access-recovery" target="_blank" rel="noopener noreferrer" href={recoveryLink.href}>{recoveryLink.text}</a>}
                    </div>
                    {error && <div className="access-error" role="alert">{error}</div>}
                    <button className="access-submit" type="submit" disabled={submitting}>
                        {submitting && <span className="access-spinner" aria-hidden="true" />}
                        {submitting ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
                <footer className="access-footer">© {new Date().getFullYear()} OnTest</footer>
            </div>
        </section>
        <aside className="access-hero" style={{ backgroundImage: `url(${background})` }}>
            <div className="access-hero-copy"><span>OnTest</span><h2>{heroTitle}</h2><p>{heroDescription}</p></div>
        </aside>
    </div>;
}

export function LoginScreenLoading() {
    return <div className="ontest-access-loading" role="status"><span className="access-spinner" aria-hidden="true" /><span>Carregando...</span></div>;
}
